import yup from '../../../../../translations/yup/yupLocale';

const validationSchema = yup.object({
  email: yup.string().email().required().label('Email'),
  cvr: yup.string().required().label('CVR'),
});

export default validationSchema;
